/**
 * Recherche dans les listes de filtres (marque, type, etc.)
 */
(function () {
  function bind(root) {
    if (!root) return;
    root.querySelectorAll("[data-lgk-facet-search]").forEach((wrap) => {
      if (wrap.dataset.lgkBound === "1") return;
      wrap.dataset.lgkBound = "1";
      const input = wrap.querySelector("[data-lgk-facet-search-input]");
      const list =
        wrap.parentElement &&
        wrap.parentElement.querySelector("[data-lgk-facet-values]");
      if (!input || !list) return;

      input.addEventListener("input", () => {
        const q = (input.value || "").trim().toLowerCase();
        list.querySelectorAll("[data-lgk-facet-value]").forEach((row) => {
          const hay = row.getAttribute("data-lgk-facet-value") || "";
          row.hidden = q !== "" && !hay.includes(q);
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll(".lgk-facets").forEach(bind);
  }

  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();
